<template>
  <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex" cols="12" sm="6">
        <v-select
          :items="eventsItems"
          :label="$t('page.events.importRegistrants.selectEvent')"
          item-text="eventName"
          item-value="id"
          v-model="eventId"
          @input="getClassByEvent"
          :no-data-text="$t('common.no_data')"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          v-model="classesIds"
          :items="classesItems"
          :menu-props="{ maxHeight: '400' }"
          :label="$t('page.events.importRegistrants.select')"
          multiple
          :hint="$t('page.events.importRegistrants.pickYourClass')"
          persistent-hint
          item-text="name"
          item-value="id"
          :no-data-text="$t('common.no_data')"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6">
        <p>
          {{ $t('page.events.importRegistrants.text1') }}
        </p>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6">
        <v-btn
          style="width: 100%"
          class="ma-2 button_"
          outlined
          @click="importRegistrants"
        >{{ $t('page.events.importRegistrants.importRegistrants') }}</v-btn>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">{{ $t('page.events.importRegistrants.close') }}</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  name: "ImportRegistrants",
  mixins: [apiCalls],
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      eventsItems: [],
      eventId: null,
      classesItems: [],
      classesIds: []
    };
  },
  methods: {
    async eventsItems_() {
      const response = await this.api(
        "get",
        "/api/v1/promoter/geteventsbypromoter"
      );
      this.eventsItems = response[0];
    },
    async getClassByEvent() {
      const response = await this.api(
        "get",
        "/api/v1/promoter/getclassbyevent/" + this.eventId
      );
      this.classesItems = [];
      this.classesIds = [];
      this.classesItems = response[0];
    },
    async importRegistrants() {
      if (this.classesIds.length == 0) {
        this.snackbar = true;
        this.snackbarText = this.$t('page.events.importRegistrants.plaeseSelectClass')
      } else {
        const response = await this.postApi(
          "/api/v1/promoter/importregistrantsbyclasses/" +
            this.$route.params.id,
            { 
              classesIds: this.classesIds,
              eventId: this.eventId 
            }
        );
        this.snackbar = true;
        this.snackbarText = this.$t(response[0]);
      }
    }
  },
  created() {
    this.eventsItems_();
  }
};
</script>

<style>
</style>
